// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.riepilogo {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}
@media (min-width: 768px) {
  .riepilogo {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.campo {
  display: flex;
  flex-direction: column;
}
.campo small {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--ion-color-step-650, #4b5563);
}
.campo b {
  font-size: 16px;
  line-height: 1.3;
  color: var(--ion-text-color);
}

.campo app-contenitore-tipo-label {
  align-self: flex-start;
}

.campo .codice-articolo {
  font-size: 19px;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.campo-desc {
  font-size: 13px;
  color: var(--ion-color-step-600, #6b7280);
}

@media (min-width: 768px) {
  .layout-affiancato {
    display: grid;
    grid-template-columns: minmax(260px, 1fr) minmax(0, 2fr);
    align-items: stretch;
  }
  .layout-affiancato > * {
    grid-column: 1/-1;
  }
  .layout-affiancato > .campo-contenitore {
    grid-column: 1;
  }
  .layout-affiancato > .card-riepilogo {
    grid-column: 2;
    grid-row: 1;
  }
}

.layout-timeline .riepilogo-colonna {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.layout-timeline .riepilogo-colonna .campo-largo {
  grid-column: 1/-1;
}
@media (min-width: 768px) {
  .layout-timeline {
    display: grid;
    grid-template-columns: minmax(280px, 1fr) minmax(0, 3fr);
    align-items: start;
    height: 100%;
  }
  .layout-timeline > .colonna-riepilogo {
    max-height: 100%;
    overflow-y: auto;
  }
  .layout-timeline > .colonna-percorso {
    margin-top: 8px;
    margin-bottom: 8px;
    max-height: calc(100% - 16px);
    overflow-y: auto;
  }
}

.avanzamento-titolo {
  display: block;
  margin-bottom: 8px;
  color: var(--ion-text-color);
}

.avanzamento-barra {
  display: flex;
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--ion-color-light-shade, #e5e7eb);
  margin-bottom: 6px;
}

.barra-passate {
  background: #2e7d4f;
}

.barra-attuale {
  background: #1d5fd6;
}

.footer-fase {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: var(--ion-background-color, #ffffff);
  border-top: 1px solid var(--ion-color-light-shade, #d1d5db);
}`, "",{"version":3,"sources":["webpack://./src/app/_components/contenitori/contenitore-info/contenitore-info.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;AAAF;AAEE;EALF;IAMI,gDAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yCAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AAAJ;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,eAAA;EACA,yCAAA;AADF;;AAOE;EADF;IAEI,aAAA;IACA,wDAAA;IACA,oBAAA;EAHF;EAKE;IACE,iBAAA;EAHJ;EAME;IACE,cAAA;EAJJ;EAOE;IACE,cAAA;IACA,WAAA;EALJ;AACF;;AAYE;EACE,gDAAA;AATJ;AAWI;EACE,iBAAA;AATN;AAaE;EATF;IAUI,aAAA;IACA,wDAAA;IACA,kBAAA;IAEA,YAAA;EAXF;EAaE;IACE,gBAAA;IACA,gBAAA;EAXJ;EAcE;IACE,eAAA;IACA,kBAAA;IACA,6BAAA;IACA,gBAAA;EAZJ;AACF;;AAgBA;EACE,cAAA;EACA,kBAAA;EACA,4BAAA;AAbF;;AAgBA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,iDAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAiBA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gDAAA;EACA,2DAAA;AAdF","sourcesContent":["// Riepilogo: etichetta piccola sopra, valore in evidenza.\n.riepilogo {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 12px;\n\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n.campo {\n  display: flex;\n  flex-direction: column;\n\n  small {\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0.02em;\n    color: var(--ion-color-step-650, #4b5563);\n  }\n\n  b {\n    font-size: 16px;\n    line-height: 1.3;\n    color: var(--ion-text-color);\n  }\n}\n\n.campo app-contenitore-tipo-label {\n  align-self: flex-start;\n}\n\n.campo .codice-articolo {\n  font-size: 19px;\n  font-weight: 800;\n  letter-spacing: .01em;\n}\n\n.campo-desc {\n  font-size: 13px;\n  color: var(--ion-color-step-600, #6b7280);\n}\n\n// Feature 166, Orizzontale e Mappa (mockup A): dai 768 px campo contenitore a sinistra e riepilogo a destra;\n// messaggi e altre card a tutta larghezza.\n.layout-affiancato {\n  @media (min-width: 768px) {\n    display: grid;\n    grid-template-columns: minmax(260px, 1fr) minmax(0, 2fr);\n    align-items: stretch;\n\n    > * {\n      grid-column: 1 / -1;\n    }\n\n    > .campo-contenitore {\n      grid-column: 1;\n    }\n\n    > .card-riepilogo {\n      grid-column: 2;\n      grid-row: 1;\n    }\n  }\n}\n\n// Feature 166, Timeline (mockup B): colonna sinistra stretta con campo contenitore, riepilogo e avanzamento;\n// il percorso occupa il resto. Sotto i 768 px una colonna.\n.layout-timeline {\n  .riepilogo-colonna {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n\n    .campo-largo {\n      grid-column: 1 / -1;\n    }\n  }\n\n  @media (min-width: 768px) {\n    display: grid;\n    grid-template-columns: minmax(280px, 1fr) minmax(0, 3fr);\n    align-items: start;\n    // Colonna sinistra ferma, scorre solo il percorso: ognuna ha il proprio scorrimento nell'altezza della finestra.\n    height: 100%;\n\n    > .colonna-riepilogo {\n      max-height: 100%;\n      overflow-y: auto;\n    }\n\n    > .colonna-percorso {\n      margin-top: 8px;\n      margin-bottom: 8px;\n      max-height: calc(100% - 16px);\n      overflow-y: auto;\n    }\n  }\n}\n\n.avanzamento-titolo {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--ion-text-color);\n}\n\n.avanzamento-barra {\n  display: flex;\n  height: 10px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: var(--ion-color-light-shade, #e5e7eb);\n  margin-bottom: 6px;\n}\n\n.barra-passate {\n  background: #2e7d4f;\n}\n\n.barra-attuale {\n  background: #1d5fd6;\n}\n\n// Feature 166, Mappa (mockup C): footer con la fase scelta nel percorso.\n.footer-fase {\n  padding: 8px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: var(--ion-background-color, #ffffff);\n  border-top: 1px solid var(--ion-color-light-shade, #d1d5db);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
